import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_saladToppings = _resolveComponent("saladToppings")!
  const _component_wingToppings = _resolveComponent("wingToppings")!
  const _component_pizzaToppings = _resolveComponent("pizzaToppings")!
  const _component_dynamicSkeleText = _resolveComponent("dynamicSkeleText")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!

  return (_openBlock(), _createBlock(_component_ion_card_content, { class: "pr-0" }, {
    default: _withCtx(() => [
      (_ctx.initialItem && _ctx.availableTopping)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_ctx.initialItem.isSalad)
              ? (_openBlock(), _createBlock(_component_saladToppings, {
                  key: 0,
                  initialItem: _ctx.initialItem,
                  availableTopping: _ctx.availableTopping,
                  parentToppingCount: _ctx.toppingCount,
                  selectedSize: _ctx.selectedSize,
                  dressing: _ctx.localDressing,
                  "onUpdate:dressing": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localDressing) = $event)),
                  toppings: _ctx.localToppings,
                  "onUpdate:toppings": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localToppings) = $event)),
                  onBlockSubmit: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('blockSubmit', $event))),
                  onLimits: _ctx.qtylimit
                }, null, 8, ["initialItem", "availableTopping", "parentToppingCount", "selectedSize", "dressing", "toppings", "onLimits"]))
              : (_ctx.initialItem.isWing || _ctx.initialItem.isAppetizer)
                ? (_openBlock(), _createBlock(_component_wingToppings, {
                    key: 1,
                    initialItem: _ctx.initialItem,
                    availableTopping: _ctx.availableTopping,
                    parentToppingCount: _ctx.toppingCount,
                    selectedSize: _ctx.selectedSize,
                    flavor: _ctx.localFlavor,
                    "onUpdate:flavor": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localFlavor) = $event)),
                    dressing: _ctx.localDressing,
                    "onUpdate:dressing": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localDressing) = $event)),
                    onBlockSubmit: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('blockSubmit', $event)))
                  }, null, 8, ["initialItem", "availableTopping", "parentToppingCount", "selectedSize", "flavor", "dressing"]))
                : (!_ctx.initialItem.isMisc && _ctx.availableTopping.toppings.length > 0)
                  ? (_openBlock(), _createBlock(_component_pizzaToppings, {
                      key: 2,
                      initialItem: _ctx.initialItem,
                      availableTopping: _ctx.availableTopping,
                      parentToppingCount: _ctx.toppingCount,
                      selectedSize: _ctx.selectedSize,
                      selectedRecipe: _ctx.selectedRecipe,
                      sauceCups: _ctx.sauceCups,
                      toppings: _ctx.localToppings,
                      "onUpdate:toppings": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.localToppings) = $event)),
                      defaultToppings: _ctx.localDefaultToppings,
                      "onUpdate:defaultToppings": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.localDefaultToppings) = $event)),
                      twoSidedItem: _ctx.localTwoSidedItem,
                      "onUpdate:twoSidedItem": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.localTwoSidedItem) = $event)),
                      dressing: _ctx.localDressing,
                      "onUpdate:dressing": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.localDressing) = $event)),
                      onBlockSubmit: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('blockSubmit', $event)))
                    }, null, 8, ["initialItem", "availableTopping", "parentToppingCount", "selectedSize", "selectedRecipe", "sauceCups", "toppings", "defaultToppings", "twoSidedItem", "dressing"]))
                  : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_dynamicSkeleText, {
              element: "div",
              childElements: [{ width: 60, height: '24px', class: 'mx-a mb-8' }]
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array.from({ length: 4 }, (_, i) => i + 1), (i) => {
              return (_openBlock(), _createBlock(_component_dynamicSkeleText, {
                key: i,
                element: "div",
                childElements: _ctx.skeleText
              }, null, 8, ["childElements"]))
            }), 128))
          ]))
    ]),
    _: 1
  }))
}